<style>
  .card {
    position: relative;
    color: white;
  }

  img {
    object-fit: cover;
    width: 100%;
  }
  .starts-in {
    position: absolute;
    top: 5px;
    left: 5px;
    padding: 5px;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .stars {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 5px;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .info {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    padding: 5px;
    /* border: 1px red solid; */
    /* margin-top: -40px; */
    background-color: rgba(0, 0, 0, 0.6);
  }
  .name {
    font-size: 21px;
  }
  .trans {
    background-color: rgba(0, 0, 0, 0.4);
    font-size: 13px;
  }

  .has-action-bar-high {
    height: 120px;
  }
  .bold {
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .preset {
    display: grid;
    grid-template-columns: auto 40px 40px;
    margin: 10px 0;
    padding: 10px;
    /* background-color: rgba(255,255,255,0.2); */
    border: 1px rgba(255, 255, 255, 0.2) solid;
    border-radius: 10px;
  }
  .preset-name {
    grid-column: 1;
  }
  .preset-trash {
    grid-column: 2;
    text-align: center;
  }
  .preset-edit {
    grid-column: 3;
    text-align: center;
  }
  .dheader {
    margin-top: 5px;
    font-size: 16px;
    text-align: left;
  }

  .days {
    display: grid;
  }
  .sun {
    grid-column: 1;
  }
  .mon {
    grid-column: 2;
    margin-left: 1px;
  }
  .tue {
    grid-column: 3;
    margin-left: 1px;
  }
  .wed {
    grid-column: 4;
    margin-left: 1px;
  }
  .thu {
    grid-column: 5;
    margin-left: 1px;
  }
  .fri {
    grid-column: 6;
    margin-left: 1px;
  }
  .sat {
    grid-column: 7;
    margin-left: 1px;
  }
  .day-button {
    background-color: rgba(0, 0, 0, 0.4);
    color: #ddd;
    font-size: 13px;
    padding: 10px;
    border: 0;
    border-radius: 5px;
  }
  .daySelected {
    background-color: #ddd;
    color: #333;
    font-weight: bold;
  }

  .interests {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .interests-button {
    width: 45%;
    height: 50px;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.4);
    color: #ddd;
    margin: 5px;
    font-size: 16px;
    font-weight: bold;
    border: 0;
  }
  .interests-button-selected {
    background-color: #ddd;
    color: #333;
  }
  .sub-item-text {
    margin-top: 15px;
    font-size: 16px;
    font-weight: bold;
    /* text-shadow: 1px 1px 3px rgba(0,0,0,1); */
  }

  .range {
    display: grid;
    grid-template-columns: auto 80px;
    align-items: center;
  }
  .range-slider {
    grid-column: 1;
  }
  .range-text {
    grid-column: 2;
  }
</style>

<Auth bind:this="{auth}"></Auth>

<!-- <Notification></Notification> -->

<Dialog
  show="{customShow}"
  title="Custom Filters"
  height="{550}"
  buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }"
  on:close="{ customFilterCancel }"
  on:done="{ customFilterDone }"
>
  <!-- Select search and filter options here, including saving presets for quick access. -->

  <Tabs
    items="{ customTabs }"
    on:presets="{presets}"
    on:filters="{filters}"
  ></Tabs>

  {#if curCustomTab == "presets"} {#each filterPresets as item, index}
  <div class="preset">
    <div class="preset-name" on:click="{ () => setFilter(index) }">
      {item.name}
    </div>
    <div class="preset-trash" on:click="{ () => deletePreset(index) }">
      <i class="icon-cancel"></i>
    </div>
    <div class="preset-edit" on:click="{ () => editPreset(index) }">
      <i class="icon-pencil3"></i>
    </div>
  </div>
  {/each} {/if} {#if curCustomTab == "filters"}

  <div class="dheader">My Interests</div>
  <div class="interests">
    {#each myInterests as item}
    <button
      class="interests-button {item.s ? 'interests-button-selected' : ''}"
      on:click="{ () => item.s = !item.s }"
    >
      {item.t}
    </button>
    {/each}
  </div>

  <div class="dheader">Days</div>
  <div class="days">
    <div class="sun">
      <button
        class="day-button {sun ? 'daySelected' : ''}"
        on:click="{ () => sun = !sun}"
      >
        Sun
      </button>
    </div>
    <div class="mon">
      <button
        class="day-button {mon ? 'daySelected' : ''}"
        on:click="{ () => mon = !mon}"
      >
        Mon
      </button>
    </div>
    <div class="tue">
      <button
        class="day-button {tue ? 'daySelected' : ''}"
        on:click="{ () => tue = !tue}"
      >
        Tue
      </button>
    </div>
    <div class="wed">
      <button
        class="day-button {wed ? 'daySelected' : ''}"
        on:click="{ () => wed = !wed}"
      >
        Wed
      </button>
    </div>
    <div class="thu">
      <button
        class="day-button {thu ? 'daySelected' : ''}"
        on:click="{ () => thu = !thu}"
      >
        Thu
      </button>
    </div>
    <div class="fri">
      <button
        class="day-button {fri ? 'daySelected' : ''}"
        on:click="{ () => fri = !fri}"
      >
        Fri
      </button>
    </div>
    <div class="sat">
      <button
        class="day-button {sat ? 'daySelected' : ''}"
        on:click="{ () => sat = !sat}"
      >
        Sat
      </button>
    </div>
  </div>

  <div class="dheader">Time Start</div>
  <div class="range">
    <div class="range-slider">
      <RangeSlider
        id=""
        min="{-1}"
        max="{23}"
        bind:values="{timeStart}"
        springValues="{ { stiffness: 0.25, damping: 0.9 } }"
      ></RangeSlider>
    </div>
    <div class="range-text">
      {#if timeStart[0] == -1} off {:else} &gt; {timeHelper(timeStart)} {/if}
    </div>
  </div>

  <div class="dheader">Price (Max)</div>
  <div class="range">
    <div class="range-slider">
      <RangeSlider
        id=""
        min="{-5}"
        max="{50}"
        step="{5}"
        bind:values="{price}"
        springValues="{ { stiffness: 0.25, damping: 0.9 } }"
      ></RangeSlider>
    </div>
    <div class="range-text">
      {#if price[0] == -5} off {:else if price[0] == 0} free {:else} &lt;
      ${price[0]} {/if}
    </div>
  </div>

  <div class="dheader">People Attending (Min)</div>
  <div class="range">
    <div class="range-slider">
      <RangeSlider
        id=""
        min="{-10}"
        max="{100}"
        step="{10}"
        bind:values="{attending}"
        springValues="{ { stiffness: 0.25, damping: 0.9 } }"
      ></RangeSlider>
    </div>
    <div class="range-text">
      {#if attending[0] == -10} off {:else} &gt; {attending[0]} {/if}
    </div>
  </div>

  {/if}
</Dialog>

<Header
  buttons="{ [ {icon: 'icon-date_range', text: 'All Upcoming Events', callback: 'upcoming', disabled: false, }, {icon: 'icon-more2', text: 'Custom Filters', callback: 'filters', disabled: false, }, ] }"
  on:filters="{ () => customShow = true }"
  on:upcoming="{ () => push('/events-upcoming') }"
  >Events</Header
>
<div class="has-header"></div>

<Tabs
  items="{ tabs }"
  on:all="{ () => push('/events/all') }"
  on:popular="{ () => push('/events/popular') }"
  on:new="{ () => push('/events/new') }"
  on:custom="{ () => push('/events/custom') }"
></Tabs>

{#if events.length} {#each events as item, index }

<EventCard
  item="{item}"
  currentTime="{currentTime}"
  on:click="{ () => push('/events-info/'+item.eid) }"
></EventCard>

{/each} {:else}

<div class="center">
  <h6>There are no events to show.</h6>
  <div class="small">
    Try searching a different area or changing your search.
  </div>
</div>

{/if} {#if curTab == "popular" || curTab == "new"}

<OverlayTools>
  <button
    class="trans {tomorrowSelected ? 'bold' : ''}"
    on:click="{tomorrowClick}"
  >
    {tomorrowSelected ? '*' : ''} Tomorrow {tomorrowSelected ? '*' : ''}
  </button>
  <button class="trans {todaySelected ? 'bold' : ''}" on:click="{todayClick}">
    {todaySelected ? '*' : ''} Today {todaySelected ? '*' : ''}
  </button>
</OverlayTools>

{/if}

<EditButton on:click="{ () => push('/edit-event/new') }"></EditButton>

<div
  class="{ curTab == 'popular' || curTab == 'new' ? 'has-action-bar-high' : 'has-action-bar' }"
></div>
<ActionBar></ActionBar>

<script>
  import { push, pop, replace, location } from "svelte-spa-router";
  export let params = {};

  import Xss from "../helpers/Xss.js";
  import DateTime from "../helpers/DateTime.js";
  import tinterests from "../helpers/InterestCategories.js";

  import Auth from "../interfaces/Auth.svelte";
  let auth;

  import RangeSlider from "svelte-range-slider-pips";

  import Header from "../components/Header.svelte";
  import ActionBar from "../components/ActionBar.svelte";
  import Stars from "../components/Stars.svelte";
  import EventTime from "../components/EventTime.svelte";
  import StartsIn from "../components/StartsIn.svelte";
  import Dialog from "../components/DialogSlide.svelte";
  // import Notification from "../components/Notification.svelte";
  import EventCard from "../components/EventCard.svelte";
  import Tabs from "../components/Tabs.svelte";
  import EditButton from "../components/EditButton.svelte";
  import OverlayTools from "../components/OverlayTools.svelte";

  let events = [];

  let interval = null;
  let currentTime = Math.round(Date.now() / 1000);

  let curTab = "";
  let tabs = [
    { name: "Popular", callback: "popular", selected: true },
    { name: "New", callback: "new", selected: false },
    { name: "All", callback: "all", selected: false },
    { name: "Custom", callback: "custom", selected: false },
  ];

  let customShow = false;
  // let curCustomTab = "filters";
  let curCustomTab = "presets";
  let customTabs = [
    { name: "Presets", callback: "presets", selected: true },
    { name: "Filters", callback: "filters", selected: false },
  ];

  // bottom toolbar on popular, new, and all tabs
  let todaySelected = true;
  let tomorrowSelected = false;

  // filterParams contains the current filter params.
  // if "custom" tab is selected, whatever is in this object
  // is used to filter the events
  let filterParams = {
    name: "",
    params: {},
    sort: "date",
  };

  // contains all the previously created user filters
  let filterPresets = [];

  // if a user is editing an already existing preset
  // this is the preset index in filterPresets
  let customFilterIndex = -1;

  // preset builder variables

  // all interests selected by the user
  let myInterests = [];

  // days that a user would like the filter to run
  let sun = false;
  let mon = false;
  let tue = false;
  let wed = false;
  let thu = false;
  let fri = false;
  let sat = false;

  // the time that the filter should run.
  // this is equal to, or greater than
  // from 0 to 23, military time...
  // -1 means "filter is turned off"
  let timeStart = [-1];

  // price to filter on
  // -5 means "filter is turned off"
  // 0 is free
  // this works in increments of +5 each slider pip.
  // this is the reason for starting at -5
  let price = [-5];

  // attending works similar to price, in that pips are in
  // increments of +10.  -10 means "filter is turned off"
  let attending = [-10];

  let mounted = false;
  import { onMount } from "svelte";
  onMount(async () => {
    // get my interests
    let me = localStorage.getItem("store");
    me = JSON.parse(me);
    let allInterests = tinterests.convert();
    myInterests = [];
    for (let i in allInterests) {
      if (
        allInterests[i].h == 1 &&
        me.interests.includes(allInterests[i].i) == true
      ) {
        myInterests.push({
          p: allInterests[i].p /* photo */,
          t: allInterests[i].t /* text */,
          s: false,
          i: allInterests[i].i,
        });
      }
    }

    // get my filters
    let filters = localStorage.getItem("eventFilters");
    if (filters != undefined) {
      filterPresets = JSON.parse(filters);
    }

    // update the event times every X minutes
    interval = setInterval(() => {
      currentTime = Math.round(Date.now() / 1000);
    }, 1000 * 60 * 1);

    mounted = true;

    update();
  });

  $: {
    if (params) set();
  }

  function set() {
    // console.log("params:", params);

    tabs[0].selected = false;
    tabs[1].selected = false;
    tabs[2].selected = false;
    tabs[3].selected = false;
    if (params.flag == "popular") tabs[0].selected = true;
    if (params.flag == "new") tabs[1].selected = true;
    if (params.flag == "all") tabs[2].selected = true;
    if (params.flag == "custom") tabs[3].selected = true;

    curTab = params.flag;

    update();
  }

  async function update() {
    if (mounted == false) return;
    // return;

    auth.message("Loading Events");

    /*   
  params: {
    dateStart: 0,
    dateEnd: 0,
    days: [],
    location: []
    interests: [],
    keywords: [],
    price: [],
    stars: {low:, high:},
    views: ,
    going: {low:, high:},
  }


  -dateStart and dateEnd contain a timestamp that filters out anything before or after.
    -between April 19th 12:00pm to April 19th 2:00pm
  -days allows you to specify anything that falls on a day.
    -Thursday
  -timeStart and timeEnd contain a timestamp that filters out anything before or after.
    -this gets combined with dateStart/End if included 
    - otherwise it uses today()
  -location allows you to specify lat/long or a city
    lat, long, radius
    -Los Angeles
  -categories allows you to add an interest that you're interested in
    -Golf, -Bars
  -keywords allows you specify any type of search constraint using words
    -Ford Park
  -price allows you specify any type of search constraint using words, but only searching the price field
    -$5 shots
    -$10 entry
  -stars allows for returning only a specific rating from low to high - two sliders
  -views allows for returning only an event with views that are higher than the specified number
  -going allows for returning only an event with people going that are between low and high than the specified number
    -low is optional and will start from 0 if not specified
  
  sort: "field"
  */

    let body = {
      page: 0,
      params: {},
      sort: "",
    };

    let start = 0,
      end = 0;

    if (todaySelected == true) ({ start, end } = today());
    if (tomorrowSelected == true) ({ start, end } = tomorrow());

    if (params.flag == "popular") {
      // params
      body.params.dateStart = start;
      body.params.dateEnd = end;
      // sort
      // body.sort = "stars"; // will eventually be this
      body.sort = "views";
    }

    if (params.flag == "new") {
      // params
      body.params.dateStart = start;
      body.params.dateEnd = end;
      // sort
      body.sort = "date";
    }

    if (params.flag == "all") {
      // sort
      body.sort = "date";
    }

    if (params.flag == "custom") {
      body.params = filterParams.params;
      // sort - this will be customizable later...
      body.sort = "date";
    }

    // console.log("body:", body);

    try {
      let rec = await auth.post("events", body);

      if (rec != "[]") {
        // need to filter any incoming data, because the server can not filter xss in encrypted data.  the clients will filter before saving, but if there is a nefarious client out there, they might be able to inject xss, bypassing any client side filtering
        rec = Xss.filter(rec);

        events = JSON.parse(rec);

        // console.log("events:", events);
      } else {
        events = [];
      }
    } catch (error) {
      console.log("error:", error);
    }
  }

  function todayClick() {
    tomorrowSelected = false;
    todaySelected = true;
    update();
  }

  function tomorrowClick() {
    tomorrowSelected = true;
    todaySelected = false;
    update();
  }

  // get todays date start and end timestamp
  function today() {
    let tdate = new Date();

    let start = new Date(
      tdate.getFullYear(),
      tdate.getMonth(),
      tdate.getDate(),
      tdate.getHours(),
      tdate.getMinutes(),
      tdate.getSeconds()
    ).getTime();
    start = Math.ceil(start / 1000);
    // console.log("start:", start);

    let end = new Date(
      tdate.getFullYear(),
      tdate.getMonth(),
      tdate.getDate(),
      23,
      59,
      59
    ).getTime();
    end = Math.ceil(end / 1000);
    // console.log("end:", end);

    return { start: start, end: end };
  }

  // get todays date start and end timestamp
  function tomorrow() {
    let tdate = new Date();

    let start = new Date(
      tdate.getFullYear(),
      tdate.getMonth(),
      tdate.getDate() + 1,
      0,
      0,
      0
    ).getTime();
    start = Math.ceil(start / 1000);
    // console.log("start:", start);

    let end = new Date(
      tdate.getFullYear(),
      tdate.getMonth(),
      tdate.getDate() + 1,
      23,
      59,
      59
    ).getTime();
    end = Math.ceil(end / 1000);
    // console.log("end:", end);

    return { start: start, end: end };
  }

  function customFilterDone() {
    if (curCustomTab == "presets") {
      customFilterCancel();
      return;
    }

    let save = false;

    let name = "";
    let interests = [];
    // get selected interest names and collect
    // all selected interests into an array
    for (let i in myInterests) {
      if (myInterests[i].s == true) {
        name += name == "" ? myInterests[i].t : ` / ${myInterests[i].t}`;
        interests.push(myInterests[i].i);
      }
    }

    let days = [];
    if (sun) days.push("sun");
    if (mon) days.push("mon");
    if (tue) days.push("tue");
    if (wed) days.push("wed");
    if (thu) days.push("thu");
    if (fri) days.push("fri");
    if (sat) days.push("sat");

    if (days.length > 0 && name == "") {
      name += `${days.join(" / ")}`;
    } else if (days.length > 0 && name != "") {
      name += ` on ${days.join(" / ")}`;
    }

    let params = {};

    // build params - only include params that have
    // been set by the user
    if (interests.length > 0) {
      params.interests = interests;
      save = true;
    }
    if (days.length > 0) {
      params.days = days;
      save = true;
    }
    if (timeStart > 0) {
      params.timeStart = timeStart[0];

      if (interests.length || days.length) {
        name += ` at ${timeHelper(timeStart)}`;
      } else {
        name += `${timeHelper(timeStart)}`;
      }
      save = true;
    }
    if (price > -5) {
      params.price = { currency: "$", min: 0, max: price[0] };
      if (name != "") {
        name += ` (${price[0] == 0 ? "free" : `<$${price[0]}`})`;
      } else {
        name += `${price[0] == 0 ? "free" : `<$${price[0]}`}`;
      }
      save = true;
    }
    if (attending > -10) {
      params.attending = attending[0];
      save = true;
    }

    if (save == true) {
      let store = { name: name, params: params, sort: "date" };

      // store filter params for "custom" tab
      filterParams = store;

      if (customFilterIndex == -1) {
        filterPresets.unshift(store);
      } else {
        filterPresets[customFilterIndex] = store;
      }

      saveFilterPresets();
      updateFilter();
    }
  }

  function customFilterCancel() {
    for (let i in myInterests) {
      myInterests[i].s = false;
    }
    sun = false;
    mon = false;
    tue = false;
    wed = false;
    thu = false;
    fri = false;
    sat = false;
    timeStart = [-1];
    price = [-5];
    attending = [-10];

    customFilterIndex = -1;

    customShow = false;
    curCustomTab = "presets";
    customTabs[0].selected = true;
    customTabs[1].selected = false;
  }

  function presets() {
    customTabs[0].selected = true;
    customTabs[1].selected = false;
    curCustomTab = "presets";
  }

  function filters() {
    customTabs[0].selected = false;
    customTabs[1].selected = true;
    curCustomTab = "filters";
  }

  function timeHelper(timeStart) {
    if (timeStart[0] == 0) {
      return "12am";
    } else if (timeStart[0] > 0 && timeStart[0] < 12) {
      return `${timeStart[0]}am`;
    } else if (timeStart[0] == 12) {
      return "12pm";
    } else {
      return `${timeStart[0] - 12}pm`;
    }
  }

  function deletePreset(index) {
    filterPresets.splice(index, 1);
    filterPresets = filterPresets;
  }

  function editPreset(index) {
    customFilterIndex = index;

    if ("interests" in filterPresets[index].params) {
      for (let i in myInterests) {
        if (
          filterPresets[index].params.interests.includes(myInterests[i].i) ==
          true
        ) {
          myInterests[i].s = true;
        }
      }
    }

    if ("days" in filterPresets[index].params) {
      sun = filterPresets[index].params.days.includes("sun");
      mon = filterPresets[index].params.days.includes("mon");
      tue = filterPresets[index].params.days.includes("tue");
      wed = filterPresets[index].params.days.includes("wed");
      thu = filterPresets[index].params.days.includes("thu");
      fri = filterPresets[index].params.days.includes("fri");
      sat = filterPresets[index].params.days.includes("sat");
    }

    if ("timeStart" in filterPresets[index].params) {
      timeStart = [filterPresets[index].params.timeStart];
    }

    if ("price" in filterPresets[index].params) {
      price = [filterPresets[index].params.price];
    }

    if ("attending" in filterPresets[index].params) {
      attending = [filterPresets[index].params.attending];
    }

    curCustomTab = "filters";
    customTabs[0].selected = false;
    customTabs[1].selected = true;

    saveFilterPresets();
  }

  function saveFilterPresets() {
    localStorage.setItem("eventFilters", JSON.stringify(filterPresets));
  }

  function setFilter(index) {
    // store filter params for "custom" tab
    filterParams = filterPresets[index];
    updateFilter();
  }

  function updateFilter() {
    customFilterCancel();

    // if we're already at /custom, we need to just
    // activate the filter
    if ($location == "/events/custom") {
      update();
    } else {
      // doing a push here will automatically
      // call update()
      push("/events/custom");
    }
  }
</script>
